import { useEffect, useLayoutEffect } from 'react'

// useLayoutEffect warns during SSR, so fall back to useEffect on the server.
// The value is chosen at module scope from a constant, never from render state,
// so it can never cause a hydration mismatch.
export const useIsomorphicLayoutEffect = typeof window !== 'undefined' ? useLayoutEffect : useEffect
